export default __webpack_public_path__ + "static/media/placeholder_man.903d3942.png";